function isCompletePayload(value) {
    return (
        value !== null &&
        typeof value === 'object' &&
        Object.prototype.hasOwnProperty.call(value, 'path') &&
        Object.prototype.hasOwnProperty.call(value, 'value')
    )
}

import ValidationService from 'services/ValidationService'

export default {
    props: {
        formData: { type: Object, required: true },
        valuePath: { type: [Number, String], default: undefined },
    },

    methods: {
        change(value) {
            const payload = isCompletePayload(value) ? value : { path: this.valuePath, value }
            this.emitEvent({ name: 'local:beforeChange', payload })
            this.emitEvent({ name: `local:beforeChange:${payload.path}`, payload })
            this.emitEvent({ name: `local:beforeChange:${payload.path.replace(/\d+/g, '*')}`, payload })

            if (ValidationService.get(this.valuePath)) {
                ValidationService.clearFieldValidation(this.valuePath)
            }

            this.emitEvent({ name: 'change', payload })

            this.emitEvent({ name: 'local:afterChange', payload })
            this.emitEvent({ name: `local:afterChange:${payload.path}`, payload })
            this.emitEvent({ name: `local:afterChange:${payload.path.replace(/\d+/g, '*')}`, payload })
        },
    },
}
